export const staffOnlinePkStatsOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  searchShow: false,
  searchBtn: false,
  refreshBtn: false,
  columnBtn: false,
  menu: false,
  addBtn: false,
  delBtn: false,
  editBtn: false,
  viewBtn: false,
  searchBtn: false,
  column: [
    {
      label: '区域',
      prop: 'regionName',
      editDisabled: true,
    },
    {
      label: '市场',
      prop: 'marketName',
      editDisabled: true,
    },
    {
      label: '总经理',
      prop: 'gmName',
      editDisabled: true,
      width: '100px',
    },
    {
      label: '营运总监',
      prop: 'doName',
      editDisabled: true,
      width: '100px',
    },
    {
      label: '营运经理',
      prop: 'omName',
      editDisabled: true,
      width: '100px',
    },
    {
      label: '营运顾问',
      prop: 'ocName',
      editDisabled: true,
      width: '100px',
    },
    {
      label: '餐厅国际编号',
      prop: 'storeCode',
      editDisabled: true,
    },
    {
      label: '餐厅名称',
      prop: 'storeName',
      editDisabled: true,
    },
    {
      label: '员工编号',
      prop: 'unionId',
      editDisabled: true,
      width: '100px',
    },
    {
      label: '员工姓名',
      prop: 'nickName',
      editDisabled: true,
    },
    {
      label: '比赛阶段',
      prop: 'pkStage',
      editDisabled: true,
    },
    {
      label: '总分',
      prop: 'score',
      editDisabled: true,
    },
    {
      label: '挑战次数',
      prop: 'pkCount',
      editDisabled: true,
    },
    {
      label: '获胜次数',
      prop: 'winCount',
      editDisabled: true,
    },
    {
      label: '失败次数',
      prop: 'loseCount',
      editDisabled: true,
    },
    {
      label: '平均答题时间/次',
      prop: 'avgTime',
      editDisabled: true,
    },
    {
      label: '挑战者答对题目数',
      prop: 'correctCount',
      editDisabled: true,
      width: '100px',
    },
    {
      label: '挑战者答错题目数',
      prop: 'wrongCount',
      editDisabled: true,
      width: '100px',
    },
  ]
}